/**
 * Payment-method vocabulary shared by the database schema and the services.
 * Kept as `as const` tuples so Postgres CHECK constraints and TypeScript unions come from one place.
 */

export const PAYMENT_METHOD_KINDS = [
  "cash",
  "credit_card",
  "debit_card",
  "prepaid_card",
  "wallet",
  "bank_transfer",
  "other",
] as const;
export type PaymentMethodKind = (typeof PAYMENT_METHOD_KINDS)[number];

/**
 * How a payment method maps a purchase date to an accounting month.
 * - same_month: accounting month = purchase month (cash, and any method the user marks as immediate)
 * - next_month: accounting month = purchase month + 1 (credit card, charged on the following statement)
 */
export const ACCOUNTING_RULES = ["same_month", "next_month"] as const;
export type AccountingRule = (typeof ACCOUNTING_RULES)[number];

/** The rule actually applied to an expense; `manual_override` records a user-chosen accounting month. */
export const APPLIED_ACCOUNTING_RULES = [...ACCOUNTING_RULES, "manual_override"] as const;
export type AppliedAccountingRule = (typeof APPLIED_ACCOUNTING_RULES)[number];
